<div class="custom-tooltip" [style.background-color]="'rgba(0,0,0,0.5)'">
    <p><span>{{ cellValue.value }}</span></p>
</div>